import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { GdprBanner } from '../gdprBanner/gdprBanner.component';
import { PrivacySettings } from '../settings/privacySettings/privacySettings.component';
import { PRIVACY_SETTINGS_EXIT_SIGNAL } from '../settings/privacySettings/privacySettings.constants';
import { toggleGdprNotice } from '../../logic/gdprNotice/gdprNotice.actions';
import { sendEvent } from '../../logic/analytics/analytics.utils';
import { SHOW_PRIVACY_SETTINGS_SIGNAL } from './cookieConcent.constants';

export class CookieConsent extends Lightning.Component {
  static _template() {
    return {
      GdprBanner: {
        visible: false,
        type: GdprBanner,
        signals: {
          [SHOW_PRIVACY_SETTINGS_SIGNAL]: '_handleShowPrivacySettings',
        },
      },
      Settings: {
        visible: false,
        type: PrivacySettings,
        signals: {
          [PRIVACY_SETTINGS_EXIT_SIGNAL]: '_handleExitPrivacySettings',
        },
      },
    };
  }

  static _states() {
    return [
      class GdprBanner extends this {
        $enter() {
          this.tag('GdprBanner').visible = true;
          this.tag('Settings').visible = false;
        }

        _getFocused() {
          return this.tag('GdprBanner');
        }
      },

      class Settings extends this {
        _handleRight() {
          return true;
        }

        $enter() {
          this.tag('GdprBanner').visible = false;
          this.tag('Settings').visible = true;
        }

        _getFocused() {
          return this.tag('Settings');
        }
      },
    ];
  }

  _focus() {
    this._setState('GdprBanner');
    this.patch({
      alpha: 1,
    });
  }

  _unfocus() {
    this.patch({
      alpha: 0,
    });
  }

  _handleExitPrivacySettings() {
    Store.dispatch(toggleGdprNotice());
  }

  _handleShowPrivacySettings() {
    sendEvent({ key: 'pressCookieBannerSetupButton' });
    this._setState('Settings');
  }
}
